import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/request'
import apis from '@/apis/index'
import router from '../router/index'
import { getMenu, flatTreeList } from '@/utils/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token'),
    user: JSON.parse(sessionStorage.getItem('user') || '{}'),
    menus: JSON.parse(sessionStorage.getItem('menus') || '[]'),
    unitList: [],
    deptList: [],
    buttonList: [],
    systemTitle: '智慧应用管理平台',
    keepAlive: []
  },
  mutations: {
    resetSession (state) {
      state.token = ''
      state.user = {}
      state.menus = []
      state.buttonList = []
      state.keepAlive = []
      state.unitList = []
      state.deptList = []
      for (const key of ['token', 'user', 'menus']) sessionStorage.removeItem(key)
    },
    setToken (state, data) {
      state.token = data
      sessionStorage.setItem('token', data)
    },
    setUser (state, data) {
      state.user = data
      sessionStorage.setItem('user', JSON.stringify(data))
    },
    setUserMenus (state, data) {
      state.menus = data
      sessionStorage.setItem('menus', JSON.stringify(data))
    },
    setUnitList (state, data) {
      state.unitList = data
    },
    setPermission (state, path) {
      const menu = getMenu(state.menus, path)
      state.buttonList = menu ? (menu.button || []) : []
    },
    setDeptList (state, data) {
      state.deptList = data
    },
    addKeepAlive (state, data) {
      if (!state.keepAlive.includes(data)) {
        state.keepAlive.push(data)
      }
    },
    removeKeepAlive (state, data) {
      const index = state.keepAlive.findIndex(item => item === data)
      state.keepAlive.splice(index, 1)
    }
  },
  getters: {
    getMenuByCode: state => code => {
      const menu = flatTreeList(state.menus).find(item => item.menuCode === code)
      return (menu ? (menu.button || []) : []).map(item => item.butCode)
    }
  },
  actions: {
    async logout ({ commit }) {
      // 服务端注销成功后再清理本地凭证；请求失败时保留会话，便于重试。
      await axios.post(apis.common.loginOut)
      commit('resetSession')
      if (router.currentRoute.path !== '/login') await router.replace('/login')
    },
    loadUserMenus ({ commit }) {
      return axios.get(apis.system.selectSysMenuMyList, {
        menuType: '1'
      }).then(res => {
        commit('setUserMenus', res)
        commit('setPermission', router.currentRoute.fullPath)
        sessionStorage.setItem('menus', JSON.stringify(res))
        return res
      })
    },
    // 企业列表
    getUnitList ({ commit }) {
      axios.get(apis.schoolCompany.selectSchoolByList).then(res => {
        commit('setUnitList', res.list)
      })
    },
    // 负责机构部门
    getDeptList ({ commit }) {
      axios.get(apis.system.selectSysDeptByList).then(res => {
        commit('setDeptList', res)
      })
    },
    setSystemTit ({ commit }, title) {
      commit('setSystemTitle', title)
    }
  },
  modules: {
  }
})
